import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import CommentListingComponent from "../../CoreComponents/CommentListingComponent";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import OrderListingComponent from "../../CoreComponents/OrderListingComponent";
import image from "../../Assets/images/profile_icon.jpg";
import NoDataComponent from "../../CoreComponents/NoDataComponent";

import axios from "axios";

import {
  is_superuser,
  url,
  is_shop_admin,
  protocol,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
} from "../../Functionalities/Config";

import {
  getLocalStorageData,
  ManageComments,
  ManageCustomer,
  ManageOrders,
  getToken,
  formatAMPM,
  showMessage,
  getAllBranches,
  substractTime,
  ManageStatus,
} from "../../Functionalities/Functions";
import { AddMoney, MakeDeliveryBoy, MakeManager } from "./Logic";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import FilterComponent from "../../CoreComponents/FilterComponent";
import FilterModalComponent from "../../CoreComponents/FilterModalComponent";
import { GET_API } from "../../Functionalities/APIs";

function Body(props) {
  let id = props.id;
  // void 0
  const [delboyData, setDelboyData] = useState({
    user_id: "",
    username: "",
    password: "",
    branch: "",
    franchise_id: ""
  });

  const [errors, setErrors] = useState([]);
  const [transactionData, setTransactionData] = useState({
    wallet_id: "",
    amount: "",
    transaction_id: "",
  });

  const [walletData, setWalletData] = useState({ user_id: "", amount: 0.0 });
  const [branches, setBranches] = useState([]);
  const [wallet, setWallet] = useState({});
  const [loading, setloading] = useState(true);
  const [data, setData] = useState([]);
  const [orders, setOrders] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [transaction, setTransaction] = useState([]);
  const [editTransaction, setEditTransaction] = useState({});
  const [next, setNext] = useState("");
  const [walletNext, setWalletNext] = useState("");
  const [prev, setPrev] = useState("");
  const [walletPrev, setWalletPrev] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [statusArray, setStatusArray] = useState([]);
  const [franchise, setFranchise] = useState([])
  const [disableButton, setdisableButton] = useState(false)

  const [isModalOpen, setisModalOpen] = useState(false)
  // const [restrarent, setrestrarent] = useState({ id: "", name: "", data: [] });
  const [filter, setfilter] = useState({
    id: "FDR",
    status_id: "",
    from_date: "",
    to_date: "",
    payment_mode: "",
    // status_array: []
    branch_id: "",
    // search_text: "",
    // delivery_boy_search: ""
  });
  useEffect(() => {
    getData();
    getOrders();
    getReviews();
    getWallet();
    getBranches();
    getStatus();
    getFranchise();
  }, []);
  // useEffect(() => {
  //   getOrders()
  // }, [filter])


  const FranchiseData = async (e, data, keyword, params) => {

    let path = "/franchise/details/"
    // let path = "/branch/details/"
    if (keyword == "get") {
      let result = GET_API("", params, path);
      // void 0
      return await result.then((result) => {
        // void 0
        if (result) {
          // void 0
          return result;
        } else {
          return 0;
        }
      });
    }
  }


  const getFranchise = () => {
    showMessage(
      "Loading Restaurant",
      "info",
      "Loading",
      "bottom",
      "bottom-left",
      0
    );

    let params = "page_wise=false&for_dropdown=true";

    let result = FranchiseData("", "", "get", params);
    result
      .then((result) => {
        // showMessage(
        //   JSON.stringify(result),
        //   "success",
        //   "Loading",
        //   "top",
        //   "top-center",
        //   0
        // );
        setFranchise(result.data);
        setloading(false);
      })
      .catch((err) => {
        showMessage(
          JSON.stringify(err),
          "danger",
          "Loading error",
          "top",
          "top-center",
          0
        );
        // void 0
      });
  };

  const getStatus = () => {
    let statusRes = ManageStatus("", "get", "", "");
    statusRes.then((result) => {
      setStatusArray(result.data);
    });
  };
  useEffect(() => {
    // showMessage("errors[0]", "danger", "Following fields required!", "top", "top-right", 0)

    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "Following fields required!",
        "top",
        "top-right",
        0
      );
    }
  }, [errors]);

  const getBranches = () => {
    let res = getAllBranches("page_wise=0&for_dropdown=1");
    res
      .then((result) => {
        setBranches(result.data);
      })
      .catch((err) => {
      });
  };
  let params =
    "id=" +
    filter.id.substr(3) +
    "&status_id=" +
    filter.status_id +
    "&from_date=" +
    filter.from_date +
    "&to_date=" +
    filter.to_date +
    "&payment_mode=" +
    filter.payment_mode +
    "&status_array=" +
    JSON.stringify(statusList) +
    "&branch_id=" +
    filter.branch_id +
    // "&search_text=" +
    // filter.search_text +
    // "&delivery_boy_search=" +
    // filter.delivery_boy_search +
    "&user_id=" +
    id;

  const getOrders = () => {
    let result = ManageOrders("", "get", "", params);
    result.then((result) => {

      setOrders(result.data.results);
      setNext(result.data.next);
      setPrev(result.data.previous);
    });
  };

  const handleNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        setOrders(response.data.results);
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };

  const handlePrev = () => {
    //alert("prev")
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        setOrders(response.data.results);
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
        // void 0
      });
  };
  const getReviews = () => {
    let result = ManageComments("", "", "get", `user_id=${id}`);
    result.then((result) => {
      setReviews(result.data.results);
    });
  };
  // void 0

  const [noData, setNoData] = useState(false);

  const getData = () => {
    let result = ManageCustomer("", "", "get", `keyword=all_profile&user_id=${id}`);
    result.then((result) => {
      if (result.data.results.length > 0) {
        setData(result.data.results[0]);
        setDelboyData({ ...delboyData, franchise_id: result.data.results[0]?.del_boy_franchise?.id })
        setloading(false);
      } else {
        setNoData(true);
        setloading(false);
      }
    });
  };

  const getWallet = () => {
    // alert('wallet api calling')
    let result = AddMoney("", "", "get", `transaction_details=true&user_id=${id}`);
    result.then((result) => {

      if (result.data) {

        // setWallet(result.data.results[0]);
        setWallet(result.data.wallet[0]);
        setTransaction(result.data.results);
        setWalletNext(result.data.next);
        setWalletPrev(result.data.previous);
      }
    });
  };

  // void 0
  const handleWalletNext = () => {
    //alert("next")
    var config = {
      method: "get",
      url: walletNext.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        // void 0
        // setOrders(response.data.results);
        setWallet(response.data.wallet[0]);
        setTransaction(response.data.results);
        setWalletNext(response.data.next);
        setWalletPrev(response.data.previous);
      })
      .catch(function (error) {
      });
  };

  const handleWalletPrev = () => {
    //alert("prev")
    var config = {
      method: "get",
      url: walletPrev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    // void 0
    axios(config)
      .then(function (response) {
        // void 0
        // setOrders(response.data.results);
        setWallet(response.data.wallet[0]);
        setTransaction(response.data.results);
        setWalletNext(response.data.next);
        setWalletPrev(response.data.previous);
      })
      .catch(function (error) {
      });
  };

  const ChangeOrderStatus = (statusDetails, index) => {
    ManageOrders("", "patch", statusDetails)
      .then((res) => {
        if (res.data.Status === true) {
          window.location.reload();
        }
      })
      .catch((err) => {
      });
  };

  const BlockAndUnBlockUser = (is_blocked) => {
    var data = new FormData();
    data.append("keyword", "block_user");
    data.append("user_id", id);
    data.append("is_blocked", is_blocked);

    var config = {
      method: "patch",
      url: url + "/user/profile/",
      headers: {
        Authorization: getToken(),
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        if (response.data.Status === true) {
          showMessage("Customer updated", "success", "Success!", "top", "top-right", 0);
          window.location.reload();
        } else {
          showMessage("Failed", "danger", "Error!", "top", "top-right", 0);
        }
      })
      .catch(function (error) {
        //alert("failed");
        showMessage("Failed", "danger", "Error!", "top", "top-right", 0);
      });
  };

  let length;
  if (wallet) {
    length =
      typeof wallet.transactions != "undefined" &&
      wallet.transactions != null &&
      wallet.transactions.length != null &&
      wallet.transactions.length > 0 &&
      wallet.transactions.length;
  }
  // void 0

  return (
    <div>
      {!loading ? (
        <>
          <div className="content-body">
            <div className="container-fluid">
              {!noData ? (
                <>
                  <div className="page-titles">
                    <div className="card-header">
                      <div className="mt-4" className="text-left">
                        <a
                          href
                          onClick={() => window.history.back()}
                          className="btn btn-primary mb-1 mr-1"
                        >
                          {" "}
                          Back{" "}
                        </a>
                      </div>

                      <div className="text-right">
                        {is_superuser && (
                          <>
                            <a
                              href=""
                              class="btn btn-primary mr-2 "
                              data-toggle="modal"
                              data-target="#SelectFranchise"
                              onClick={() => setisModalOpen(true)}
                            >
                              {data.is_delivery_boy ? 'Change Franchise' : 'Make Delivery Boy'}{" "}
                            </a>

                            {/*add wallet money  */}
                            <a
                              href=""
                              class="btn btn-primary mr-2 "
                              data-toggle="modal"
                              data-target="#sendMessageModal2"
                            >
                              Add Wallet Money{" "}
                            </a>
                          </>
                        )}

                        {data.is_branch_admin ||
                          data.is_manager ||
                          data.is_delivery_boy ? (
                          <a></a>
                        ) : (
                          <>
                            {(is_franchise_admin ||
                              is_franchise_manager ||
                              is_franchise_staff) && (
                                <a
                                  href=""
                                  class="btn btn-primary mr-2 "
                                  data-toggle="modal"
                                  data-target="#sendMessageModal"
                                >
                                  Make Delivery Boy
                                </a>
                              )}
                            {(is_franchise_admin ||
                              is_franchise_manager ||
                              is_franchise_staff) && (
                                <a
                                  href=""
                                  class="btn btn-primary "
                                  data-toggle="modal"
                                  data-target="#sendMessageModal1"
                                >
                                  {" "}
                                  Make Manager
                                </a>
                              )}
                          </>
                        )}

                        <div className={isModalOpen ? "modal fade show" : "modal fade"} id="SelectFranchise">
                          <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  {data.is_delivery_boy ? 'Change Franchise' : 'Add Franchise'}
                                </h5>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                  onClick={() => setDelboyData({
                                    user_id: "",
                                    username: "",
                                    password: "",
                                    branch: "",
                                    franchise_id: ""
                                  })}
                                >
                                  <span>×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <form className="comment-form">
                                  <div className="row ">
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <div className="form-group  text-left">
                                          <label className="text-black font-w600">
                                            Username
                                            <span className="required">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={delboyData.username}
                                            onChange={(e) => {
                                              setDelboyData({
                                                ...delboyData,
                                                user_id: data.id,
                                                username: e.target.value,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <div className="form-group  text-left">
                                          <label className="text-black font-w600">
                                            Password
                                            <span className="required">*</span>
                                          </label>
                                          <input
                                            type="password"
                                            className="form-control"
                                            value={delboyData.password}
                                            onChange={(e) => {
                                              setDelboyData({
                                                ...delboyData,
                                                password: e.target.value,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-lg-6 text-center"></div>
                                    <div className="col-lg-12 ">
                                      <div className="form-group  text-left">
                                        <label className="text-black font-w600">
                                          Franchise
                                          <span className="required">*</span>
                                        </label>
                                        <select

                                          className="form-control"
                                          // value={}
                                          onKeyDown={(evt) =>
                                            ((evt.key === "e" ||
                                              evt.key === "-") &&
                                              evt.preventDefault()) ||
                                            (evt.key === "E" &&
                                              evt.preventDefault())
                                          }
                                          onWheelCapture={(e) => {
                                            e.target.blur();
                                          }}
                                          onChange={(e) => {
                                            setDelboyData({ ...delboyData, franchise_id: e.target.value });
                                          }}
                                          value={`${delboyData.franchise_id}`}
                                        // defaultValue={data.del_boy_franchise.name}
                                        >

                                          {/* <option value={data.del_boy_franchise && data.del_boy_franchise.id} > {data.del_boy_franchise ? data.del_boy_franchise.name : 'Select Franchise'} </option> */}
                                          <option value={''}>Select Franchise</option>
                                          {franchise?.map(data => (
                                            <option value={data.id}>{data.name} </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <div className="form-group mb-0 text-center">
                                        <button
                                          style={{ marginRight: 10 }}
                                          data-dismiss="modal"
                                          type="submit"
                                          id="tests"
                                          defaultValue="Post Comment"
                                          className="submit btn btn-primary"
                                          name="submit"
                                          onClick={() => setDelboyData({
                                            user_id: "",
                                            username: "",
                                            password: "",
                                            branch: "",
                                            franchise_id: ""
                                          })}
                                        >
                                          Cancel
                                        </button>

                                        <input
                                          type="submit"
                                          className="submit btn btn-primary"
                                          name="submit"
                                          onClick={(e) => {
                                            e.preventDefault();

                                            if (delboyData.username === "") {
                                              setErrors(["username"]);
                                              return;
                                            }

                                            if (delboyData.password === "") {
                                              setErrors(["Password"]);
                                              return;
                                            }
                                            if (delboyData.franchise_id === "") {
                                              setErrors(["Franchise"]);
                                              return;
                                            }



                                            let result = MakeDeliveryBoy(
                                              e,
                                              delboyData,
                                              "add",
                                              ``
                                            );
                                            result
                                              .then((result) => {
                                                if (
                                                  result.data.Status === true
                                                ) {
                                                  // alert("success");
                                                  setisModalOpen(false)
                                                  setDelboyData({
                                                    user_id: "",
                                                    username: "",
                                                    password: "",
                                                    branch: "",
                                                  });
                                                  showMessage(
                                                    "Customer is promoted as delivery boy",
                                                    "success",
                                                    "Success!",
                                                    "top",
                                                    "top-right",
                                                    0
                                                  );
                                                  window.location.reload();
                                                } else {
                                                  showMessage(
                                                    result.data.Error,
                                                    "danger",
                                                    "Error!",
                                                    "top",
                                                    "top-right",
                                                    0
                                                  );
                                                }
                                              })
                                              .catch((err) => {
                                                showMessage(
                                                  "Error",
                                                  "danger",
                                                  "Error!",
                                                  "top",
                                                  "top-right",
                                                  0
                                                );
                                              });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="modal fade" id="sendMessageModal2">
                          <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  Add Money to Wallet
                                </h5>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                >
                                  <span>×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <form className="comment-form">
                                  <div className="row ">
                                    <div className="col-lg-6 text-center"></div>
                                    <div className="col-lg-12 text-center">
                                      <div className="form-group text-center">
                                        <label className="text-black font-w600">
                                          Amount
                                          <span className="required"></span>
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={walletData.amount}
                                          onKeyDown={(evt) =>
                                            ((evt.key === "e" ||
                                              evt.key === "-") &&
                                              evt.preventDefault()) ||
                                            (evt.key === "E" &&
                                              evt.preventDefault())
                                          }
                                          onWheelCapture={(e) => {
                                            e.target.blur();
                                          }}
                                          onChange={(e) => {
                                            setWalletData({
                                              ...walletData,
                                              user_id: data.id,
                                              amount: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <div className="form-group mb-0 text-center">
                                        <button
                                          style={{ marginRight: 10 }}
                                          data-dismiss="modal"
                                          type="submit"
                                          id="tests"
                                          defaultValue="Post Comment"
                                          className="submit btn btn-primary"
                                          name="submit"
                                        >
                                          Cancel
                                        </button>
                                        <input
                                          type="submit" disabled={disableButton}
                                          className="submit btn btn-primary"

                                          name="submit"
                                          onClick={(e) => {
                                            setdisableButton(true)
                                            e.preventDefault();
                                            // return 0
                                            let result = AddMoney(
                                              e,
                                              [walletData],
                                              "add",
                                              ""
                                            );
                                            result
                                              .then((result) => {
                                                if (
                                                  result.data.Status === true
                                                ) {
                                                  showMessage(
                                                    "Added money to wallet",
                                                    "success",
                                                    "Success!",
                                                    "top",
                                                    "top-right",
                                                    0
                                                  );
                                                  setWalletData({
                                                    user_id: "",
                                                    amount: "",
                                                  });
                                                  window.location.reload();
                                                  setdisableButton(false)
                                                } else {
                                                  showMessage(
                                                    result.data.Error,
                                                    "danger",
                                                    "Error!",
                                                    "top",
                                                    "top-right",
                                                    0
                                                  );
                                                  setdisableButton(false)
                                                }
                                              })
                                              .catch((err) => {
                                                showMessage(
                                                  "Error",
                                                  "danger",
                                                  "Error!",
                                                  "top",
                                                  "top-right",
                                                  0
                                                );
                                                setdisableButton(false)
                                              });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="modal fade" id="sendMessageModaldeduct">
                          <div className="modal-dialog modal-dialog-centered" role="document" >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  Deduct Money From Wallet
                                </h5>
                                <button type="button" className="close" data-dismiss="modal" >
                                  <span>×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <form className="comment-form">
                                  <div className="row ">
                                    <div className="col-lg-6 text-center"></div>
                                    <div className="col-lg-12 text-center">
                                      <div className="form-group text-center">
                                        <label className="text-black font-w600">
                                          Amount
                                          <span className="required"></span>
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control"
                                          value={walletData.amount}
                                          onKeyDown={(evt) => ((evt.key === "e" || evt.key === "-") && evt.preventDefault()) || (evt.key === "E" && evt.preventDefault())}
                                          onWheelCapture={(e) => { e.target.blur(); }}
                                          onChange={(e) => {
                                            setWalletData({
                                              ...walletData,
                                              user_id: data.id,
                                              amount: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <div className="form-group mb-0 text-center">
                                        <button style={{ marginRight: 10 }} data-dismiss="modal" type="submit" id="tests" defaultValue="Post Comment" className="submit btn btn-primary" name="submit" >
                                          Cancel
                                        </button>
                                        <input type="submit" disabled={disableButton} className="submit btn btn-primary" name="submit"
                                          onClick={(e) => {
                                            setdisableButton(true)
                                            e.preventDefault();
                                            var wall = parseFloat(walletData.amount) * -1;
                                            setWalletData({
                                              ...walletData,
                                              amount: wall,
                                            });
                                            var x = {
                                              ...walletData,
                                              amount: wall,
                                            };
                                            let result = AddMoney(e, [x], "add", "");
                                            result.then((result) => {
                                              if (result.data.Status === true) {
                                                showMessage("Added money to wallet", "success", "Success!", "top", "top-right", 0);
                                                setWalletData({ user_id: "", amount: "", });
                                                window.location.reload();
                                                setdisableButton(false)
                                              } else {
                                                showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0);
                                                setdisableButton(false)
                                              }
                                            })
                                              .catch((err) => {
                                                showMessage("Error", "danger", "Error!", "top", "top-right", 0);
                                                setdisableButton(false)
                                              });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="modal fade " id="sendMessageModal1">
                          <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Make Manager</h5>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                >
                                  <span>×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <form className="comment-form">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div
                                        className="form-group"
                                        style={{ textAlign: "center" }}
                                      >
                                        <label className="text-black font-w600">
                                          Username{" "}
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={delboyData.username}
                                          onChange={(e) => {
                                            setDelboyData({
                                              ...delboyData,
                                              user_id: data.id,
                                              username: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div
                                        className="form-group"
                                        style={{ textAlign: "center" }}
                                      >
                                        <label className="text-black font-w600">
                                          password{" "}
                                          <span className="required">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          value={delboyData.password}
                                          onChange={(e) => {
                                            setDelboyData({
                                              ...delboyData,
                                              password: e.target.value,
                                            });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-lg-8">
                                      <div
                                        className="form-group"
                                        style={{ textAlign: "center" }}
                                      >
                                        <label className="text-black font-w600">
                                          Restaurant
                                          <span className="required">*</span>
                                        </label>
                                        <select
                                          value={delboyData.branch}
                                          class="form-control form-control-lg  "
                                          onChange={(e) => {
                                            // setData({ ...data, branch: e.target.value })

                                            setDelboyData({
                                              ...delboyData,
                                              branch: e.target.value,
                                            });
                                          }}
                                        >
                                          <option value={""}>
                                            ---Select Restaurant---
                                          </option>
                                          {branches.length > 0 &&
                                            branches.map((item) => (
                                              <option value={item.id}>
                                                {item.name}
                                              </option>
                                            ))}
                                        </select>
                                      </div>
                                    </div>
                                    <div className="col-lg-12">
                                      <div
                                        className="form-group mb-0"
                                        style={{ textAlign: "center" }}
                                      >
                                        <button
                                          style={{ marginRight: 10 }}
                                          data-dismiss="modal"
                                          type="submit"
                                          id="tests"
                                          defaultValue="Post Comment"
                                          className="submit btn btn-primary"
                                          name="submit"
                                          onClick={(e) => {
                                            setDelboyData({
                                              user_id: "",
                                              username: "",
                                              password: "",
                                              branch: "",
                                            });
                                          }}
                                        >
                                          Cancel
                                        </button>
                                        <input
                                          type="submit"
                                          defaultValue="Post Comment"
                                          className="submit btn btn-primary"
                                          name="submit"
                                          onClick={(e) => {
                                            showMessage(
                                              "Normal user is changed to Manager ",
                                              "success",
                                              "Success!",
                                              "top",
                                              "to-right",
                                              0
                                            );
                                            e.preventDefault();
                                            setErrors([]);
                                            if (delboyData.username === "") {
                                              setErrors(["username"]);
                                              return;
                                            }
                                            if (delboyData.password === "") {
                                              setErrors(["Password"]);
                                              return;
                                            }
                                            if (delboyData.branch === "") {
                                              setErrors(["Restaurant"]);
                                              return;
                                            }
                                            if (data.branch === "") {
                                              setErrors(["Restaurant"]);
                                              return;
                                            }
                                            showMessage(
                                              "Error",
                                              "danger",
                                              "Error!",
                                              "top",
                                              "to-right",
                                              0
                                            );

                                            let result = MakeManager(
                                              e,
                                              delboyData,
                                              "add",
                                              ""
                                            );
                                            result
                                              .then((result) => {
                                                if (
                                                  result.data.Status === true
                                                ) {
                                                  // alert("success");
                                                  showMessage(
                                                    "Normal user is changed to Manager ",
                                                    "success",
                                                    "Success!",
                                                    "top",
                                                    "to-right",
                                                    0
                                                  );
                                                  window.location.reload();
                                                } else {
                                                  // void 0
                                                  showMessage(
                                                    result.data.Error,
                                                    "danger",
                                                    "Error!",
                                                    "top",
                                                    "to-right",
                                                    0
                                                  );
                                                }
                                                setDelboyData({
                                                  user_id: "",
                                                  username: "",
                                                  password: "",
                                                  branch: "",
                                                });
                                              })
                                              .catch((err) => {
                                                showMessage(
                                                  "Error",
                                                  "danger",
                                                  "Error!",
                                                  "top",
                                                  "to-right",
                                                  0
                                                );
                                              });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="modal fade" id="sendMessageModal">
                          <div
                            className="modal-dialog modal-dialog-centered"
                            role="document"
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  Make Delivery Boy
                                </h5>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                >
                                  <span>×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <form className="comment-form">
                                  <div className="row">
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <div className="form-group text-center">
                                          <label className="text-black font-w600">
                                            Username
                                            <span className="required">*</span>
                                          </label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            value={delboyData.username}
                                            onChange={(e) => {
                                              setDelboyData({
                                                ...delboyData,
                                                user_id: data.id,
                                                username: e.target.value,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-lg-6">
                                      <div className="form-group">
                                        <div className="form-group text-center">
                                          <label className="text-black font-w600">
                                            Password
                                            <span className="required">*</span>
                                          </label>
                                          <input
                                            type="password"
                                            className="form-control"
                                            value={delboyData.password}
                                            onChange={(e) => {
                                              setDelboyData({
                                                ...delboyData,
                                                password: e.target.value,
                                              });
                                            }}
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-lg-12">
                                      <div className="form-group mb-0 text-center">
                                        <button
                                          style={{ marginRight: 10 }}
                                          data-dismiss="modal"
                                          type="submit"
                                          id="tests"
                                          defaultValue="Post Comment"
                                          className="submit btn btn-primary"
                                          name="submit"
                                          onClick={(e) => {
                                            setDelboyData({
                                              user_id: "",
                                              username: "",
                                              password: "",
                                              branch: "",
                                            });
                                          }}
                                        >
                                          Cancel
                                        </button>
                                        <input
                                          type="submit"
                                          className="submit btn btn-primary"
                                          name="submit"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            if (delboyData.username === "") {
                                              setErrors(["username"]);
                                              return;
                                            }

                                            if (delboyData.password === "") {
                                              setErrors(["Password"]);
                                              return;
                                            }

                                            let result = MakeDeliveryBoy(
                                              e,
                                              delboyData,
                                              "add",
                                              ""
                                            );
                                            result
                                              .then((result) => {
                                                if (
                                                  result.data.Status === true
                                                ) {
                                                  // alert("success");
                                                  setDelboyData({
                                                    user_id: "",
                                                    username: "",
                                                    password: "",
                                                    branch: "",
                                                  });
                                                  showMessage(
                                                    "Customer is promoted as delivery boy",
                                                    "success",
                                                    "Success!",
                                                    "top",
                                                    "top-right",
                                                    0
                                                  );
                                                  window.location.reload();
                                                } else {
                                                  showMessage(
                                                    result.data.Error,
                                                    "danger",
                                                    "Error!",
                                                    "top",
                                                    "top-right",
                                                    0
                                                  );
                                                }
                                              })
                                              .catch((err) => {
                                                showMessage(
                                                  "Error",
                                                  "danger",
                                                  "Error!",
                                                  "top",
                                                  "top-right",
                                                  0
                                                );
                                              });
                                          }}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* row */}
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="profile card card-body px-3 pt-3 pb-0">
                        <div className="profile-head">
                          <div className="photo-content">
                            {/* <div className="cover-photo" /> */}{" "}
                          </div>
                          <div className="profile-info">
                            <div className="profile-photo" style={{ textAlign: 'center' }}>
                              {data.images != null ? (
                                <img
                                  className="img-fluid rounded-circle"
                                  src={url + data.images}
                                  alt="Foodoor"
                                />
                              ) : (
                                <img
                                  className="img-fluid rounded-circle"
                                  src={image}
                                  alt="Foodoor"
                                />
                              )}{" "}
                              <span>{data.is_delivery_boy && "delivery boy" || data.is_branch_admin && "branch admin" || data.is_franchise_admin && "franchise admin" || data.is_franchise_staff && "francise staff" || data.is_franchise_manager && "franchise manager" || data.is_manager && "restaurant manager"}</span>
                            </div>

                            <div className="profile-details">
                              <div className="profile-name px-4 pt-2">
                                <p>Name</p>
                                <h4 className="text-primary mb-0">
                                  {data.first_name
                                    ? data.first_name
                                    : "Customer Name"}{" "}
                                </h4>
                              </div>
                              {/* <div className="profile-email px-2 pt-2">
                        <h4 className="text-muted mb-0">
                          {data.email ? data.email : "No Email"}
                        </h4>
                        <p>Email</p>
                      </div> */}
                              <div className="profile-email px-4 pt-2">
                                <p>Address</p>
                                <h4 className="text-muted mb-0">
                                  {data.address && data.address.length > 0
                                    ? data.address[0].address1
                                    : "No address"}{" "}
                                </h4>
                              </div>
                              <div className="profile-email px-4 pt-2">
                                <p>Phone</p>
                                <h4 className="text-muted mb-0">
                                  {data.details
                                    ? data.details.mobile
                                    : "No number"}{" "}
                                </h4>
                              </div>
                              <div className="profile-email px-4 pt-2">
                                <p>E-Mail</p>
                                <h4 className="text-muted mb-0">
                                  {data.email ? data.email
                                    : "no email"}{" "}
                                </h4>
                              </div>
                              {/* <div className="profile-email px-3 pt-2 ml-5">
                          <h4 className="text-muted mb-0">
                            {wallet ? wallet.amount : "No Money"} </h4>
                          <p>Wallet</p>
                        </div> */}

                              {is_superuser && <div className="dropdown ml-auto">
                                <a
                                  href="#"
                                  className="btn btn-primary light sharp"
                                  data-toggle="dropdown"
                                  aria-expanded="true"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    width="18px"
                                    height="18px"
                                    viewBox="0 0 24 24"
                                    version="1.1"
                                  >
                                    <g
                                      stroke="none"
                                      strokeWidth={1}
                                      fill="none"
                                      fillRule="evenodd"
                                    >
                                      <rect
                                        x={0}
                                        y={0}
                                        width={24}
                                        height={24}
                                      />
                                      <circle
                                        fill="#000000"
                                        cx={5}
                                        cy={12}
                                        r={2}
                                      />
                                      <circle
                                        fill="#000000"
                                        cx={12}
                                        cy={12}
                                        r={2}
                                      />
                                      <circle
                                        fill="#000000"
                                        cx={19}
                                        cy={12}
                                        r={2}
                                      />
                                    </g>
                                  </svg>
                                </a>
                                <ul className="dropdown-menu dropdown-menu-right">
                                  {data.details && (
                                    <a
                                      onClick={() =>
                                        BlockAndUnBlockUser(
                                          !data.details.is_blocked
                                        )
                                      }
                                    >
                                      <li className="dropdown-item">
                                        <i className="fa fa-ban text-primary mr-2" />{" "}
                                        {data.details.is_blocked
                                          ? "Unblock"
                                          : "Block"}
                                      </li>
                                    </a>
                                  )}
                                </ul>
                              </div>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="post-details">
                            <h4 class="fs-20 font-w600">Orders</h4>
                            <FilterComponent
                              tab={"Customer orders"}
                              handleNext={handleNext}
                              handlePrev={handlePrev}
                              next={next}
                              prev={prev}
                              filterButtonName={"Filter"}
                              // count={count}
                              functionFilter={(value, e) => {
                                setStatusList([]);
                                for (let i = 0; i < value.length; i++) {
                                  // void 0
                                  setStatusList((statusList) => [
                                    ...statusList,
                                    value[i],
                                  ]);
                                }
                              }}
                            />
                            <FilterModalComponent
                              heading={"Filter Orders"}
                              fromDateValue={filter.from_date.slice(0, 10)}
                              fromDateChange={(e) => {
                                setfilter({
                                  ...filter,
                                  from_date: e.target.value + " 00:00:00",
                                });
                              }}
                              toDateValue={filter.to_date.slice(0, 10)}
                              toDateChange={(e) => {
                                setfilter({
                                  ...filter,
                                  to_date: e.target.value + " 00:00:00",
                                });
                              }}
                              clearFilter={(e) => {
                                e.preventDefault();
                                window.location.reload();
                              }}
                              submitFilter={(e) => {
                                e.preventDefault();
                                getOrders();
                              }}
                            >
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label className="text-black font-w600">
                                    Order ID <span className="required"></span>
                                  </label>
                                  <div className="form-group">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="name"
                                      placeholder="Order Id"
                                      value={filter.id}
                                      onChange={(e) =>
                                        setfilter({
                                          ...filter,
                                          id: e.target.value,
                                        })
                                      }
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label className="text-black font-w600">
                                    Status <span className="required"></span>
                                  </label>
                                  <div className="form-group">
                                    <select
                                      value={filter.status_id}
                                      class="form-control form-control-lg  "
                                      onChange={(e) =>
                                        setfilter({
                                          ...filter,
                                          status_id: e.target.value,
                                        })
                                      }
                                    >
                                      <option value={""} id={""}>
                                        All
                                      </option>

                                      {statusArray.map((item) => (
                                        <option value={item.id} id={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              </div>

                              <div className="col-lg-6">
                                <div className="form-group">
                                  <label className="text-black font-w600">
                                    Payment Mode{" "}
                                    <span className="required"></span>
                                  </label>
                                  <div className="form-group">
                                    <select
                                      value={filter.payment_mode}
                                      class="form-control form-control-lg  "
                                      onChange={(e) =>
                                        setfilter({
                                          ...filter,
                                          payment_mode: e.target.value,
                                        })
                                      }
                                    >
                                      <option value={""} id={""}>
                                        All
                                      </option>
                                      <option value={"COD"} id={"COD"}>
                                        Cash On Delivery
                                      </option>
                                      <option value={"ONLINE"} id={"ONLINE"}>
                                        Online Payment
                                      </option>
                                    </select>
                                  </div>
                                </div>
                              </div>

                              {(is_franchise_admin ||
                                is_franchise_manager ||
                                is_franchise_staff) && (
                                  <div className="col-lg-6">
                                    <div className="form-group">
                                      <label className="text-black font-w600">
                                        Restaurant{" "}
                                        <span className="required"></span>
                                      </label>
                                      <select
                                        value={filter.branch_id}
                                        class="form-control form-control-lg"
                                        onChange={(e) =>
                                          setfilter({
                                            ...filter,
                                            branch_id: e.target.value,
                                          })
                                        }
                                      >
                                        <option value={""} id={""}>
                                          All
                                        </option>
                                        {branches.map((item) => (
                                          <option value={item.id} id={item.id}>
                                            {item.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                )}
                            </FilterModalComponent>

                            <table
                              className="table border-no order-table mb-4 table-responsive-lg dataTablesCard"
                              id="example5"
                            >
                              <thead>
                                <tr>
                                  <th>ORDER ID</th>
                                  <th>DATE</th>
                                  <th>LOCATION</th>
                                  {(is_franchise_admin ||
                                    is_franchise_manager ||
                                    is_franchise_staff) && <th>RESTAURANT</th>}
                                  <th>AMOUNT</th>
                                  <th>ORDER STATUS</th>
                                  <th />
                                </tr>
                              </thead>
                              <tbody>
                                {" "}
                                {orders.length > 0
                                  ? orders.map((item, index) => {
                                    return (
                                      <OrderListingComponent
                                        item={item}
                                        cutomerOrder={true}
                                        accept={() =>
                                          ChangeOrderStatus({
                                            id: "2",
                                            orderid: item.id,
                                            desc: "",
                                            keyword: "change_status",
                                          })
                                        }
                                        reject={() =>
                                          ChangeOrderStatus({
                                            id: "3",
                                            orderid: item.id,
                                            desc: "",
                                            keyword: "change_status",
                                          })
                                        }
                                      />
                                    );
                                  })
                                  : "No Orders found"}{" "}
                              </tbody>
                            </table>
                            {/* dsdss */}{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* wallect section */}

                  {true ? (
                    <>
                      <div className="row justify-content-center">
                        <div className="col-xl-3 col-xxl-4">
                          <div style={{ backgroundColor: "white", borderRadius: 20, }} >
                            <div className="text-center">
                              <h5 style={{ paddingTop: 20 }}  > Wallet Balance ( User {wallet?.is_activated === true ? "" : "Not "} Recharged )</h5>
                            </div>

                            <div style={{ backgroundColor: "white", borderRadius: 20, }} >
                              <div className="widget-timeline-icon2 text-center">
                                <h1>₹ {wallet?.amount}</h1>
                                <br></br>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-group text-center">
                                    <p>IN <i className="fa fa-arrow-down text-success" /> </p>
                                    <h4>
                                      ₹{" "}{wallet?.amount_details?.admin_updated.amount_in__sum ? wallet?.amount_details.admin_updated.amount_in__sum : "0"}
                                    </h4>
                                    <br></br>
                                  </div>
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="form-group">
                                  <div className="form-group text-center">
                                    <p><i className="fa fa-arrow-up text-danger" /> OUT</p>
                                    <h4>
                                      ₹{" "}{wallet?.amount_details?.amount_used.amount_out__sum ? wallet?.amount_details.amount_used.amount_out__sum : "0"}
                                    </h4>
                                    <br></br>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {is_superuser &&
                              <div className="text-center">
                                {wallet?.amount != 0 && (<a href="" class="btn btn-primary text-center mb-2 " data-toggle="modal" data-target="#sendMessageModaldeduct" > Deduct Wallet Money{" "} </a>)}
                              </div>
                            }

                          </div>
                          <br></br>
                        </div>

                        <div className="col-lg-12 ">
                          <div className="row">
                            <div className="col-xl-12 col-xxl-12">
                              {/* below code is commented */}
                              {false && (
                                <div style={{ backgroundColor: "white", borderRadius: 20, }} >
                                  <div className="card-body">
                                    <h4 className="fs-20 font-w600 text-center"> Wallet Transactions </h4>
                                    <div style={{ backgroundColor: "white", borderRadius: 20, }} >
                                      <h4 className="card-title" style={{ paddingTop: 15 }} > Second Transaction </h4>
                                      <div className="basic-form">
                                        <form>
                                          <div className="form-row">
                                            <div className="form-group col-md-6">
                                              <label>Current Amount</label>
                                              <input onWheelCapture={(e) => { e.target.blur(); }} value={wallet.transactions[length - 2].amount_in} type="number" min={0} readOnly className="form-control"
                                                onKeyDown={(evt) =>
                                                  ((evt.key === "e" || evt.key === "-") && evt.preventDefault()) || (evt.key === "E" && evt.preventDefault())
                                                }
                                              />
                                            </div>
                                            <div className="form-group col-md-6">
                                              <label>Change New Amount</label>
                                              <input type="text" className="form-control" value={transactionData.amount}
                                                onChange={(e) => {
                                                  setTransactionData({
                                                    ...transactionData,
                                                    wallet_id: wallet.id,
                                                    amount: e.target.value,
                                                  });
                                                }}
                                              />
                                            </div>
                                          </div>

                                          <button type="submit" className="btn btn-primary"
                                            onClick={(e) => {

                                              let result = AddMoney(e, [transactionData], "update", "");
                                              result.then((result) => {
                                                if (result.data.Status === true) {
                                                  showMessage("Wallet updated", "success", "Success!", "top", "top-right", 0);

                                                  window.location.reload();
                                                } else {
                                                  showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0);

                                                }
                                              })
                                                .catch((err) => {
                                                  showMessage("Something went wrong", "danger", "Error!", "top", "top-right", 0);

                                                });
                                            }}
                                          >
                                            Chanage Wallet Amount
                                          </button>
                                        </form>
                                      </div>
                                    </div>
                                    {/* )} */}

                                    <h4 className="card-title" style={{ paddingTop: 15 }} > Last Transaction </h4>

                                    <div className="basic-form mb-2">
                                      <form>
                                        <div className="form-row">
                                          <div className="form-group col-md-6">
                                            <label>Amount</label>
                                            <input
                                              type="number"
                                              onKeyDown={(evt) =>
                                                ((evt.key === "e" || evt.key === "-") && evt.preventDefault()) || (evt.key === "E" && evt.preventDefault())
                                              }
                                              onWheelCapture={(e) => { e.target.blur(); }}
                                              value={wallet.transactions[length - 1].amount_in}
                                              min={0}
                                              readOnly
                                              className="form-control"
                                            />
                                          </div>
                                          <div className="form-group col-md-6">
                                            <label>Change New Amount</label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={transactionData.amount}
                                              onChange={(e) => {
                                                setTransactionData({
                                                  ...transactionData,
                                                  wallet_id: wallet.id,
                                                  transaction_id:
                                                    wallet.transactions[
                                                      length - 1
                                                    ].id,
                                                  amount: e.target.value,
                                                });
                                              }}
                                            />
                                          </div>
                                        </div>

                                        <button type="submit" className="btn btn-primary" onClick={(e) => {

                                          let result = AddMoney(e, [transactionData], "update", "");
                                          result.then((result) => {
                                            if (result.data.Status === true) {
                                              showMessage("Money added", "success", "Success!", "top", "top-right", 0);
                                              setTransactionData({ amount: "", });
                                              window.location.reload();

                                            } else {
                                              showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0);

                                            }
                                          })
                                            .catch((err) => {
                                              showMessage("Error", "danger", "Error!", "top", "top-right", 0);

                                            });
                                        }}
                                        >
                                          Change Wallet Amount
                                        </button>
                                      </form>
                                    </div>
                                    {/* } */}
                                  </div>
                                </div>
                              )}
                            </div>


                            {/* Wallet Transaction History */}
                            <div className="col-xl-12 mt-4">
                              <div className="card">
                                <div style={{ backgroundColor: "white", borderRadius: 20, }} >
                                  <div class="card-header border-0 pb-0">
                                    <h4 class="fs-20 font-w600">Wallet Transaction History</h4>
                                  </div>
                                  <div div class="card-body pb-0">
                                    <div class="widget-timeline-icon2">
                                      <ul class="timeline">
                                        {transaction.map((tran, index) => {
                                          return (
                                            <>
                                              <li>
                                                <div class="icon bg-primary" />
                                                <a class="timeline-panel text-muted">
                                                  {is_superuser &&
                                                    <h4 class="mb-2 "> {tran.transaction_type}
                                                      {index === 0 && <span onClick={() => setEditTransaction(tran)} style={{ color: "white", cursor: "pointer", fontSize: 13, padding: 3, backgroundColor: "#3fb049", borderRadius: 8, marginLeft: 5, }} data-toggle="modal" data-target="#sendMessageModal3" > Edit </span>}
                                                    </h4>
                                                  }
                                                  <div>
                                                    <div className="d-flex">
                                                      <h6 class="fs-15 mb-0">
                                                        {/* {<i class={`fa ${tran.amount_in>0?'fa-plus-circle':'fa-minus-circle'}`} aria-hidden="true" >{" "}</i>} */}
                                                        {/* {tran.amount_in>0 ?tran.amount_in:tran.amount_out} */}
                                                        <i className="fa fa-arrow-up text-success">₹ {tran.amount_in}</i>
                                                        <br />
                                                        <i className="fa fa-arrow-down text-danger">₹ {tran.amount_out}</i>

                                                      </h6>
                                                    </div>
                                                    <p className="fs-15 mb-0 ">
                                                      {new Date(tran.timestamp).toDateString() + " ( " + new Date(tran.timestamp).toString().slice(16, 25) + " )"}
                                                      {/* {new Date(tran.timestamp).toDateString() + " " + formatAMPM(new Date(tran.timestamp))} */}
                                                      <br />
                                                      {tran.amount_in > 0 ? tran.amount_in_details : tran.amount_out_details}
                                                    </p>
                                                  </div>
                                                </a>

                                              </li>

                                              {/* edit wallet transaction component */}
                                              <div className="modal fade" id="sendMessageModal3" >
                                                <div className="modal-dialog modal-dialog-centered" role="document" >
                                                  <div className="modal-content">
                                                    <div className="modal-header">
                                                      <h5 className="modal-title"> Edit Wallet transaction </h5>
                                                      <button type="button" className="close" data-dismiss="modal" >
                                                        <span>×</span>
                                                      </button>
                                                    </div>
                                                    <div className="modal-body">
                                                      <form>
                                                        <div className="form-row">
                                                          <div className="form-group col-md-6">
                                                            <label> Current Amount </label>
                                                            <input type="number" value={editTransaction.amount_in} min={0} readOnly className="form-control" />
                                                          </div>
                                                          <div className="form-group col-md-6">
                                                            <label> Change New Amount </label>
                                                            <input type="number" onKeyDown={(evt) => ((evt.key === "e" || evt.key === "-") && evt.preventDefault()) || (evt.key === "E" && evt.preventDefault())}
                                                              onWheelCapture={(e) => { e.target.blur(); }}
                                                              className="form-control"
                                                              value={transactionData.amount}
                                                              onChange={(e) => { setTransactionData({ ...transactionData, wallet_id: wallet.id, transaction_id: editTransaction.id, amount: e.target.value, }); }}
                                                            />
                                                          </div>
                                                        </div>
                                                        <button type="submit" disabled={disableButton} className="btn btn-primary" style={{ marginTop: 10, }}
                                                          onClick={(e) => {
                                                            setdisableButton(true)
                                                            let result = AddMoney(e, [transactionData,], "update", "");
                                                            result.then((result) => {
                                                              if (result.data.Status === true) {
                                                                showMessage("Money added", "success", "Success!", "top", "top-right", 0);
                                                                setTransactionData({ amount: "", });
                                                                window.location.reload();
                                                                setdisableButton(false)
                                                              } else {
                                                                showMessage(result.data.Error, "danger", "Error!", "top", "top-right", 0);
                                                                setdisableButton(false)
                                                              }
                                                            }
                                                            ).catch((err) => {
                                                              showMessage("Error", "danger", "Error!", "top", "top-right", 0);
                                                              setdisableButton(false)
                                                            });
                                                          }}
                                                        >
                                                          Update
                                                        </button>
                                                      </form>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </>
                                          );
                                        })}
                                      </ul>
                                    </div>
                                  </div>
                                  {/* )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-xl-5 col-md-6 col-sm-8 col-12">
                        <FilterComponent
                          tab={"wallet history"}
                          handleNext={handleWalletNext}
                          handlePrev={handleWalletPrev}
                          next={walletNext}
                          prev={walletPrev}
                        />
                      </div>
                    </>
                  ) :
                    <span>User Wallet not activated</span>
                  }

                  <div className="card-body">
                    <div className="post-details">
                      <h3 className="mb-2 text-black">Comments</h3>
                      <div>
                        {" "}
                        {reviews.length > 0 ? (
                          <div className="card-body p-0">
                            {reviews.map((item, index) => {
                              return (
                                <CommentListingComponent
                                  review={item}
                                  user={true}
                                />
                              );
                            })}{" "}
                          </div>
                        ) : (
                          <div className="card-body p-0">No Comments found</div>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <NoDataComponent data="customer found" />
              )}
            </div>
          </div>
        </>
      ) : (
        <LoadingComponent />
      )}
    </div>
  );
}

function Customer() {
  const header = "Customer Details";
  let { id } = useParams();
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={header} />
        <NavBar />
        <Body id={id} />
        <Footer />
      </div>
    </div>
  );
}

export default Customer;
